import React from 'react';
import { Header } from 'components';
import './HomePageLayout.scss';

interface HomePageLayoutProps {
  children: React.ReactNode;
}

function HomePageLayout({ children }: HomePageLayoutProps) {
  return (
    <div className="home-page-layout">
      <div className="home-page-layout-header">
        <Header />
      </div>
      <div className="home-page-layout-content">{children}</div>
    </div>
  );
}

export default HomePageLayout;
